import React from 'react';
import { Link } from 'react-router-dom';

const PageNotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4 text-center">
      <div className="max-w-sm w-full">
        <img 
          className="w-full h-auto" 
          src="../images/404/—Pngtree—error 404 page not found_6681621.png" 
          alt="404 Not Found"
        />
        <h1 className="text-2xl sm:text-4xl font-extrabold text-gray-900 mb-4">
          404 - Page Not Found
        </h1>
        <p className="text-gray-600 text-lg sm:text-xl mb-6">
          Sorry, the page you are looking for does not exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-3 text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-md transition focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
        >
          Go Back to Home
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
